import { render, staticRenderFns } from "./ProductUpdateComponent.vue?vue&type=template&id=239ca860&scoped=true"
import script from "./ProductUpdateComponent.vue?vue&type=script&lang=js"
export * from "./ProductUpdateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239ca860",
  null
  
)

export default component.exports